(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recipe-products')) {
    class RecipeProducts extends HTMLElement {
      connectedCallback() {
        this.statusEl = this.querySelector('[data-status]');
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
      }

      onClick(event) {
        const target = event.target;
        const toggle = target.closest('[data-toggle]');
        const qtyBtn = target.closest('[data-qty-step]');
        const addBtn = target.closest('[data-add]');
        const addAll = target.closest('[data-add-all]');

        if (toggle) return this.toggleCard(toggle.closest('[data-product-card]'));
        if (qtyBtn) return this.stepQty(qtyBtn);
        if (addBtn) return this.addOne(addBtn.closest('[data-product-card]'), addBtn);
        if (addAll) return this.addAllItems(addAll);
      }

      onChange(event) {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const max = parseInt(input.max, 10);
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
      }

      toggleCard(card) {
        const willOpen = !card.classList.contains('is-open');
        this.querySelectorAll('[data-product-card].is-open').forEach((c) => this.setOpen(c, false));
        this.setOpen(card, willOpen);
      }

      setOpen(card, open) {
        card.classList.toggle('is-open', open);
        const btn = card.querySelector('[data-toggle]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      stepQty(btn) {
        const input = btn.closest('.rp-qty').querySelector('[data-qty-input]');
        const step = parseInt(btn.dataset.qtyStep, 10);
        const max = parseInt(input.max, 10);
        let val = (parseInt(input.value, 10) || 1) + step;
        if (val < 1) val = 1;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
      }

      setStatus(message, isError) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message || '';
        this.statusEl.classList.toggle('is-error', !!isError);
      }

      async addOne(card, btn) {
        const id = parseInt(card.dataset.variantId, 10);
        const qty = parseInt(card.querySelector('[data-qty-input]').value, 10) || 1;
        const label = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        try {
          await this.postItems([{ id, quantity: qty }]);
          btn.textContent = btn.dataset.addedLabel || 'Added';
          this.setStatus('');
          setTimeout(() => { btn.textContent = label; }, 2000);
        } catch (err) {
          this.setStatus(err.message, true);
        } finally {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      }

      async addAllItems(btn) {
        const cards = [...this.querySelectorAll('[data-product-card][data-available="true"]')];
        if (!cards.length) return this.setStatus('These products are currently sold out.', true);
        const items = cards.map((card) => ({
          id: parseInt(card.dataset.variantId, 10),
          quantity: 1,
        }));
        const labelEl = btn.querySelector('[data-add-all-label]');
        const original = labelEl.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        try {
          await this.postItems(items);
          labelEl.textContent = 'Added to cart';
          this.setStatus('');
          setTimeout(() => { labelEl.textContent = original; }, 2500);
        } catch (err) {
          this.setStatus(err.message, true);
        } finally {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      }

      async postItems(items) {
        const res = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const json = await res.json();
        if (!res.ok) {
          throw new Error(json.description || json.message || 'Sorry, we could not add that to your cart.');
        }
        await this.afterAdd();
      }

      async afterAdd() {
        const mode = this.dataset.afterAdd;
        if (mode === 'cart_page') {
          window.location.href = this.dataset.cartUrl;
          return;
        }
        let cart = null;
        try {
          cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        } catch (e) { /* non-fatal */ }

        // Best-effort notification so the theme's header cart count / drawer can refresh.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: { source: 'recipe-products', itemCount: cart ? cart.item_count : undefined },
            },
          })
        );

        if (mode === 'drawer') {
          const drawer = document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = this.dataset.cartUrl;
        }
      }
    }
    customElements.define('recipe-products', RecipeProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smart-collection-grid')) {
    class SmartCollectionGrid extends HTMLElement {
      constructor() {
        super();
        this.lastFocus = null;
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
      }

      connectedCallback() {
        this.statusEl = this.querySelector('[data-status]');
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.body.style.overflow = '';
      }

      /* ---------- events ---------- */
      onDocClick(e) {
        if (!e.target.closest('.tc-card')) this.closeAllCards();
      }

      onKey(e) {
        if (e.key === 'Escape') this.closeModal();
      }

      onClick(e) {
        const t = e.target;
        const toggle = t.closest('[data-toggle]');
        const qtyBtn = t.closest('[data-qty-step]');
        const addBtn = t.closest('[data-add]');
        const more = t.closest('[data-load-more]');
        const openF = t.closest('[data-open-filters]');
        const closeF = t.closest('[data-close-filters]');
        const applyF = t.closest('[data-apply-filters]');
        const clearF = t.closest('[data-clear-filters]');
        const modal = t.closest('[data-modal]');

        if (toggle) return this.toggleCard(toggle.closest('[data-card]'));
        if (qtyBtn) return this.stepQty(qtyBtn);
        if (addBtn) return this.addOne(addBtn.closest('[data-card]'), addBtn);
        if (more) { e.preventDefault(); return this.loadMore(more); }
        if (openF) return this.openModal(openF);
        if (closeF) return this.closeModal();
        if (applyF) return this.applyFilters();
        if (clearF) return this.clearFilters();
        if (modal && t === modal) return this.closeModal();
      }

      onChange(e) {
        const sort = e.target.closest('[data-sort]');
        if (sort) return this.changeSort(sort.value);
        const input = e.target.closest('[data-qty-input]');
        if (input) this.clampQty(input);
      }

      /* ---------- cards ---------- */
      toggleCard(card) {
        const willOpen = !card.classList.contains('is-open');
        this.closeAllCards();
        this.setOpen(card, willOpen);
      }

      setOpen(card, open) {
        card.classList.toggle('is-open', open);
        const btn = card.querySelector('[data-toggle]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      closeAllCards() {
        this.querySelectorAll('[data-card].is-open').forEach((c) => this.setOpen(c, false));
      }

      clampQty(input) {
        const max = parseInt(input.max, 10);
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
      }

      stepQty(btn) {
        const input = btn.closest('.tc-qty').querySelector('[data-qty-input]');
        input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
        this.clampQty(input);
      }

      setStatus(message, isError) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message || '';
        this.statusEl.classList.toggle('is-error', !!isError);
      }

      /* ---------- cart ---------- */
      async addOne(card, btn) {
        const id = parseInt(card.dataset.variantId, 10);
        const qty = parseInt(card.querySelector('[data-qty-input]').value, 10) || 1;
        const label = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] }),
          });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Sorry, we could not add that to your cart.');
          btn.textContent = btn.dataset.addedLabel || 'Added!';
          this.setStatus('');
          await this.afterAdd();
          setTimeout(() => {
            btn.textContent = label;
            this.setOpen(card, false);
            card.querySelector('[data-qty-input]').value = 1;
          }, 1200);
        } catch (err) {
          this.setStatus(err.message, true);
          btn.textContent = label;
        } finally {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      }

      async afterAdd() {
        const mode = this.dataset.afterAdd;
        if (mode === 'cart_page') {
          window.location.href = this.dataset.cartUrl;
          return;
        }
        let cart = null;
        try {
          cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        } catch (e) { /* non-fatal */ }

        if (cart) {
          document
            .querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count')
            .forEach((el) => {
              el.textContent = cart.item_count;
            });
        }

        // Best-effort notifications so the theme header count / drawer can refresh.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: { source: 'smart-collection-grid', itemCount: cart ? cart.item_count : undefined },
            },
          })
        );

        if (mode === 'drawer') {
          const drawer = document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = this.dataset.cartUrl;
        }
      }

      /* ---------- filters / sort ---------- */
      openModal(trigger) {
        const modal = this.querySelector('[data-modal]');
        if (!modal) return;
        this.lastFocus = trigger;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        modal.focus();
      }

      closeModal() {
        const modal = this.querySelector('[data-modal]');
        if (!modal || !modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        if (this.lastFocus) this.lastFocus.focus();
      }

      buildUrl(tags) {
        const url = new URL(this.dataset.collectionUrl, window.location.origin);
        if (tags.length) url.pathname = url.pathname.replace(/\/$/, '') + '/' + tags.join('+');
        const sort = new URLSearchParams(window.location.search).get('sort_by');
        if (sort) url.searchParams.set('sort_by', sort);
        return url.toString();
      }

      applyFilters() {
        const tags = [...this.querySelectorAll('[data-tag-checkbox]:checked')].map((cb) => cb.dataset.tag);
        window.location.href = this.buildUrl(tags);
      }

      clearFilters() {
        window.location.href = this.buildUrl([]);
      }

      changeSort(value) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }

      /* ---------- load more ---------- */
      async loadMore(btn) {
        const nextUrl = btn.dataset.nextUrl;
        if (!nextUrl) return;
        const label = btn.textContent;
        btn.textContent = 'Loading...';
        btn.setAttribute('aria-busy', 'true');
        try {
          const html = await (await fetch(nextUrl)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sectionId = this.dataset.sectionId;
          const source = doc.querySelector(`#tc-${sectionId}`) || doc;
          const grid = this.querySelector('[data-grid]');

          source.querySelectorAll('[data-grid] > .tc-grid__item').forEach((item) => {
            grid.appendChild(document.importNode(item, true));
          });

          const shownEl = this.querySelector('[data-count-shown]');
          if (shownEl) shownEl.textContent = grid.children.length;

          const nextBtn = source.querySelector('[data-load-more]');
          if (nextBtn) {
            btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.textContent = label;
            btn.removeAttribute('aria-busy');
          } else {
            btn.closest('.tc-more').remove();
          }
        } catch (err) {
          btn.textContent = 'Error - try again';
          btn.removeAttribute('aria-busy');
          setTimeout(() => { btn.textContent = label; }, 2000);
        }
      }
    }
    customElements.define('smart-collection-grid', SmartCollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-search-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smart-search-grid')) {
    class SmartSearchGrid extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
      }

      connectedCallback() {
        this.statusEl = this.querySelector('[data-status]');
        document.addEventListener('click', this.onDocClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
      }

      onDocClick(e) {
        if (!e.target.closest('.tc-card')) this.closeAllCards();
      }

      onClick(e) {
        const t = e.target;
        const toggle = t.closest('[data-toggle]');
        const qtyBtn = t.closest('[data-qty-step]');
        const addBtn = t.closest('[data-add]');
        const more = t.closest('[data-load-more]');

        if (toggle) return this.toggleCard(toggle.closest('[data-card]'));
        if (qtyBtn) return this.stepQty(qtyBtn);
        if (addBtn) return this.addOne(addBtn.closest('[data-card]'), addBtn);
        if (more) { e.preventDefault(); return this.loadMore(more); }
      }

      onChange(e) {
        const input = e.target.closest('[data-qty-input]');
        if (input) this.clampQty(input);
      }

      toggleCard(card) {
        const willOpen = !card.classList.contains('is-open');
        this.closeAllCards();
        this.setOpen(card, willOpen);
      }

      setOpen(card, open) {
        card.classList.toggle('is-open', open);
        const btn = card.querySelector('[data-toggle]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      closeAllCards() {
        this.querySelectorAll('[data-card].is-open').forEach((c) => this.setOpen(c, false));
      }

      clampQty(input) {
        const max = parseInt(input.max, 10);
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
      }

      stepQty(btn) {
        const input = btn.closest('.tc-qty').querySelector('[data-qty-input]');
        input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
        this.clampQty(input);
      }

      setStatus(message, isError) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message || '';
        this.statusEl.classList.toggle('is-error', !!isError);
      }

      async addOne(card, btn) {
        const id = parseInt(card.dataset.variantId, 10);
        const qty = parseInt(card.querySelector('[data-qty-input]').value, 10) || 1;
        const label = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] }),
          });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Sorry, we could not add that to your cart.');
          btn.textContent = btn.dataset.addedLabel || 'Added!';
          this.setStatus('');
          await this.afterAdd();
          setTimeout(() => {
            btn.textContent = label;
            this.setOpen(card, false);
            card.querySelector('[data-qty-input]').value = 1;
          }, 1200);
        } catch (err) {
          this.setStatus(err.message, true);
          btn.textContent = label;
        } finally {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      }

      async afterAdd() {
        const mode = this.dataset.afterAdd;
        if (mode === 'cart_page') {
          window.location.href = this.dataset.cartUrl;
          return;
        }
        let cart = null;
        try {
          cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        } catch (e) { /* non-fatal */ }

        if (cart) {
          document
            .querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count')
            .forEach((el) => { el.textContent = cart.item_count; });
        }

        // Best-effort notification so the theme header count / drawer can refresh.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: { source: 'smart-search-grid', itemCount: cart ? cart.item_count : undefined },
            },
          })
        );

        if (mode === 'drawer') {
          const drawer = document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = this.dataset.cartUrl;
        }
      }

      async loadMore(btn) {
        const nextUrl = btn.dataset.nextUrl;
        if (!nextUrl) return;
        const label = btn.textContent;
        btn.textContent = 'Loading...';
        btn.setAttribute('aria-busy', 'true');
        try {
          const html = await (await fetch(nextUrl)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector(`#ts-${this.dataset.sectionId}`) || doc;
          const grid = this.querySelector('[data-grid]');

          source.querySelectorAll('[data-grid] > .tc-grid__item').forEach((item) => {
            grid.appendChild(document.importNode(item, true));
          });

          const nextBtn = source.querySelector('[data-load-more]');
          if (nextBtn) {
            btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.textContent = label;
            btn.removeAttribute('aria-busy');
          } else {
            btn.remove();
          }
        } catch (err) {
          btn.textContent = 'Error - try again';
          btn.removeAttribute('aria-busy');
          setTimeout(() => { btn.textContent = label; }, 2000);
        }
      }
    }
    customElements.define('smart-search-grid', SmartSearchGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
